import { render, staticRenderFns } from "./UploadDocumentosEmpresa.vue?vue&type=template&id=40021201&scoped=true"
import script from "./UploadDocumentosEmpresa.vue?vue&type=script&lang=js"
export * from "./UploadDocumentosEmpresa.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentosEmpresa.vue?vue&type=style&index=0&id=40021201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40021201",
  null
  
)

export default component.exports